module.exports = __webpack_public_path__ + "static/Leo-0ec27ff5a0e10532705faa814a9a19c5.jpg";